"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const microscopeIcon = require("./microscope-icon.svg");
const SVG = require("react-inlinesvg").default;
const Icon = require("@atlaskit/icon").default;
const svg = React.createElement(SVG, { src: microscopeIcon });
class MicroscopeIcon extends React.Component {
    render() {
        return React.createElement(Icon, Object.assign({ size: "large", glyph: () => svg }, this.props));
    }
}
exports.MicroscopeIcon = MicroscopeIcon;
